<template>
<div class="row backgroundForm">

    <!-- <div class="text-center">
        <img :src="path_code" height="150px">
    </div>
    <br> -->
    <!-- <div class="col-12 col-md-5 offset-md-1">
        <h5>Cuadro Asignación Tareas <button class="btn btn-success" :disabled="animate_update" @click="mCallTasks"><font-awesome-icon icon="sync-alt" :spin="animate_update" />
        </button></h5> 
        <div class="list-group" v-for="lt in list_tasks" :key="lt.id">
            <a href="#" class="list-group-item list-group-item-action" :class="lt.dias_resto<=0 ? 'list-group-item-danger':'list-group-item-success'" @click="mVerDocumento(lt.id_task)">
                <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{lt.tipodoc}}</h5>
                <small>vence en {{ lt.dias_resto }} dias</small>
                </div>
                <p class="mb-1">{{ lt.ruta }}</p>
                <p class="mb-1">{{ lt.resume }}</p>
                <small>FR: {{ mFechaNatural(lt.fecha_emision) }} - FV: {{ mFechaNatural(lt.fecha_conclusion) }}</small>
            </a>
        </div>
    </div> -->
    <div class="col-12 col-md-10 offset-md-1">
        <div id="accordion">
            <div class="card">
                <div class="card-header" id="headingOne">
                <h5 class="mb-0">
                    <button class="btn btn-success btn-block" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" @click="callRole">
                        <font-awesome-icon icon="book" size="3x" /> <br>Enlaces 
                    </button>
                </h5>
                </div>

                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                        <!-- <div class="alert alert-secondary" v-for="l in links" :key="l.id">
                                <router-link class="alert-link" to="/dashboard/approved-enrollment">Aprobacion Matriculas</router-link>
                        </div>  -->
                        <div class="card-body">
                            <div class="alert alert-secondary " v-for="l in links" :key="l.id">
                                <a :href ="l.link" class="alert-link" target="_blank">{{ l.title }}</a>
                            </div>                    
                        </div>                  
                    </div>
                </div>
            </div>            
        </div>
    </div>
            
</div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

export default {
    name:'menu-central',
    data(){
        return{
            oper:false,
            guest:false,
            admin:false,
            supadmin:false,
            finance:false,
            security:false,
            enrollment:false,
            path_code:null,
            uumm:false,
            links:[],
            list_tasks:[],
            animate_update:false
        }        
    },
    mounted(){        
        // this.callRole()
        this.mCallInit();
    },
    computed:{
        cUserSession(){
            return this.$store.getters.getUserState.roleAssign;
        },
        c_oper(){
            return this.oper;
        },
        c_guest(){
            return this.guest;
        },
        c_admin(){
            return this.admin;
        },
        c_supadmin(){
            return this.supadmin;
        },
        c_security(){
            return this.security;
        },
        c_finance(){
            return this.finance;
        },
        c_enrollment(){
            return this.enrollment;
        },
        c_uumm(){
            return this.uumm;
        }        
    },
    methods:{
        mFechaNatural(el) {
            return this.$dateWrite(el);
        },
        async mVerDocumento(idTask){
            console.log('viendo la foto del mensaje naval')
            let url_report=btoa(`pdfTasks/${idTask}`)
            let route = this.$router.resolve({path: `/report/${url_report}`});
            // let route = this.$router.resolve('/link/to/page'); // This also works.
            // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
            window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
        },
        async mCallTasks(){
            this.animate_update=true;
            let tasks= await axios.get(`getTasksCaptains?api_token=${Vue.auth.getToken()}`);
            // console.log(tasks);
            this.list_tasks=tasks.data;
            setTimeout(()=>{
                this.animate_update=false;
            }, 2000)
        },
        async mCallInit(){
            this.links=[];
            let photo = await axios.get(`getPhotoGroup?api_token=${Vue.auth.getToken()}`);
            let link_aux = await axios.get(`getLinks?api_token=${Vue.auth.getToken()}`);
            link_aux.data.forEach(el => {
                let aux={link:el.link, title:el.title}
                this.links.push(aux);
            });
            let ext_aux=photo.data.extention;
            let ext;
            switch (ext) {
                case "jpg":
                ext = "jpeg";
                break;

                case "png":
                ext = "png";
                break;
            }

            this.path_code= `data:image/${ext};base64,${photo.data.path}`;
        },
        callRole(){
            switch(this.cUserSession){
                case 'SUPER ADMINISTRADOR':
                    this.supadmin=true;
                    this.admin=false;
                    this.oper=false;
                    this.security=false;
                    this.enrollment=false;
                    this.finance=false;
                    this.guest=false;
                break;

                case 'OPERADOR CAPITANIA':
                    this.supadmin=false;
                    this.admin=false;
                    this.oper=true;
                    this.security=false;
                    this.enrollment=false;
                    this.finance=false;
                    this.guest=false;
                break;

                case 'SEGURIDAD':
                    this.supadmin=false;
                    this.admin=false;
                    this.oper=false;
                    this.security=true;
                    this.enrollment=false;
                    this.finance=false;
                    this.guest=false;
                break;

                case 'FINANCIERO':
                    this.supadmin=false;
                    this.admin=false;
                    this.oper=false;
                    this.security=false;
                    this.enrollment=false;
                    this.finance=true;
                    this.guest=false;
                break;

                case 'MATRICULACION':
                    this.supadmin=false;
                    this.admin=false;
                    this.oper=false;
                    this.security=false;
                    this.enrollment=true;
                    this.finance=false;
                    this.guest=false;
                break;

                case 'MARINA MERCANTE':
                    this.supadmin=false;
                    this.admin=false;
                    this.oper=false;
                    this.security=false;
                    this.enrollment=false;
                    this.finance=false;
                    this.uumm=true;
                    this.guest=false;
                break;

                default:
                    this.supadmin=false;
                    this.admin=false;
                    this.oper=false;
                    this.security=false;
                    this.enrollment=false;
                    this.finance=false;
                    this.uumm=false;
                    this.guest=true;
                break;
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/dashboard/MenuCentral.vue